/* eslint-disable func-style */
import { useState, useEffect } from "react";

interface windowDimensions {
  height: number | undefined;
  width: number | undefined;
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState<windowDimensions>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      // Set window width/height to state
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // only execute all the code below in client side
    if (typeof window !== "undefined") {
      // Handler to call on window resize

      // Add event listener
      window.addEventListener("resize", handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return windowDimensions;
};
